"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tooltipMediaWidth = exports.tooltipMediaHeight = exports.TooltipWrap = exports.TooltipVideo = exports.TooltipImage = exports.TooltipContainer = exports.TooltipCloseButton = exports.TooltipButton = exports.TitleWrapper = exports.MediaWrapper = void 0;
var _react = require("@linaria/react");
var _intents = _interopRequireDefault(require("@ux/intents"));
const intents = new _intents.default();
const tooltipMediaWidth = exports.tooltipMediaWidth = 348;
const tooltipMediaHeight = exports.tooltipMediaHeight = 232;
const TitleWrapper = exports.TitleWrapper = /*#__PURE__*/(0, _react.styled)("div")({
  name: "TitleWrapper",
  class: "t1tlddwg"
});
const TooltipButton = exports.TooltipButton = /*#__PURE__*/(0, _react.styled)("button")({
  name: "TooltipButton",
  class: "t4hcp3e"
});
const TooltipCloseButton = exports.TooltipCloseButton = /*#__PURE__*/(0, _react.styled)("button")({
  name: "TooltipCloseButton",
  class: "tobuf4z",
  vars: {
    "tobuf4z-0": [({
      small
    }) => small ? '0.15rem' : '0.75rem']
  }
});
const TooltipContainer = exports.TooltipContainer = /*#__PURE__*/(0, _react.styled)("div")({
  name: "TooltipContainer",
  class: "t11073uc"
});
const TooltipWrap = exports.TooltipWrap = /*#__PURE__*/(0, _react.styled)("div")({
  name: "TooltipWrap",
  class: "taamrau",
  vars: {
    "taamrau-0": [({
      backgroundColor
    }) => backgroundColor || intents.ux.box.foregroundColor]
  }
});
const MediaWrapper = exports.MediaWrapper = /*#__PURE__*/(0, _react.styled)("div")({
  name: "MediaWrapper",
  class: "mkustre"
});
const TooltipImage = exports.TooltipImage = /*#__PURE__*/(0, _react.styled)("img")({
  name: "TooltipImage",
  class: "t1f50uzu"
});
const TooltipVideo = exports.TooltipVideo = /*#__PURE__*/(0, _react.styled)("video")({
  name: "TooltipVideo",
  class: "tsvg8mn"
});